import { Link } from "react-router-dom";
import { guides } from "@/mocks/guides";
import type { Guide } from "@/types/content";
import GuideCard from "@/components/feature/GuideCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function GuidesPreview() {
  const featured = (guides as Guide[]).slice(0, 3);

  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="维权指南"
          title="出了问题，知道该找谁、怎么说"
          desc="从固定证据到提交投诉，把流程写成可以直接照做的步骤，减少在多个渠道之间来回奔波。"
        />
        <Link
          to="/guides"
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-label text-sm font-medium text-primary-700 transition-colors hover:text-primary-800 cursor-pointer"
        >
          查看全部指南
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {featured.map((guide) => (
          <GuideCard key={guide.id} guide={guide} />
        ))}
      </div>
    </section>
  );
}